import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Order as Entity } from './order.model';
import { IPageInfo, IResultWithPageInfo } from '../app-store.interfaces';

export interface OrderState extends EntityState<Entity> {
    entities: { [id: number]: Entity };
    ids: number[];
    isLoading: boolean;
    error: Error | undefined;
    currentPage: IPageInfo;
    currentEntityId: number | undefined;
    history: { correlationId: string; payload: Entity | Entity[] | IResultWithPageInfo<Entity> }[];
}

export const orderEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>({
    selectId: (entity: Entity) => entity.id,
});

export const initialState: OrderState = orderEntityAdapter.getInitialState({
    entities: [],
    ids: [],
    isLoading: false,
    error: undefined,
    currentPage: { page: { pageNumber: 0, pageSize: 25 }, totalCount: 0 },
    history: [],
    currentEntityId: undefined,
});
